import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "d-flex w-100" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "col-6" }

import { getEntityTranslation } from "@/helpers";
import providePersonFormInfo from "@/types/symbols/providePersonFormInfo";
import { AlertManager } from "@hakosalo/hakolib";
import { inject, nextTick, onMounted, ref, watch } from "vue";
import FormSection from "../FormSection.vue";
import StartupperFormFields from "./StartupperFormFields.vue";

import publicFormApi from "@/publicFormApi";
import { ValidationFailureDto } from "@api/validation-failure-dto";
import { cloneDeep, values } from "lodash";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import FormSectionHeader from "../FormSectionHeader.vue";

import { useLiveValidation, useValidation } from "@/composables/fields";
import { DraftStartupperFormDataDto } from "@api/draft-startupper-form-data-dto";

interface PrivacyPolicyAccepts {
	[key: number]: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperForm',
  emits: ["saveSuccess", "saveFailed"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const makeHttps = (url: string) => {
	url = url.indexOf("://") === -1 ? "https://" + url : url;
	return url;
};

const blankDraft = ref<DraftStartupperFormDataDto | null>(null);

const resetFormData = () => {
	formData.value = cloneDeep(blankDraft.value);
};

onMounted(() => {
	publicFormApi.call.personForm.get.getStartupperDraft().then((r) => {
		if (r.isSuccessful) {
			formData.value = r.data;
			blankDraft.value = cloneDeep(r.data);
		}
	});
});

const isSaving = ref(false);

const formDataComputed = computed({
	get() {
		return formData.value;
	},
	set(v) {
		formData.value = v;
	},
});

// Inject validation system
const { validationErrors, validationStateMap } = useValidation<DraftStartupperFormDataDto | null>();

const validationEndpoint = publicFormApi.call.validation.post.validateStartupperProperties;

useLiveValidation<DraftStartupperFormDataDto | null>(
	validationEndpoint,
	formDataComputed,
	validationErrors,
	validationStateMap
);

const save = () => {
	if (!formData.value) {
		return;
	}

	isSaving.value = true;
	publicFormApi.call.personForm.post
		.saveStartupper(formData.value)
		.then(async (r) => {
			if (r.isSuccessful && r.data) {
				emit("saveSuccess");
				return;
			} else if (r.isHandledFailure && r.error && r.error.codeName == "ValidationError") {
				await AlertManager.alert(t("generic.checkFields"), t("generic.fixInvalidInputs"));

				validationErrors.value =
					(r.error.data as ValidationFailureDto[]) || ([] as ValidationFailureDto[]);

				nextTick(() => {
					// from dom search all elements with class invalid-feedback that have display:block
					const invalidFeedbacks = Array.from(document.querySelectorAll(".invalid-feedback"));

					// Filter elements that have display:block
					const visibleInvalidFeedbacks = invalidFeedbacks.filter(
						(el) => window.getComputedStyle(el).display === "block"
					);

					if (visibleInvalidFeedbacks.length > 0) {
						// Select parent of the first element
						const parent = visibleInvalidFeedbacks[0].parentElement;

						if (parent) {
							// Select first input inside the parent
							const input = parent.querySelector("input");

							if (input) {
								// Scroll to the first input
								input.scrollIntoView({ block: "center" });
								input.focus();
							}
						}
					}
				});
				return;
			}
			emit("saveFailed");
		})
		.finally(() => {
			isSaving.value = false;
		});
};

const clear = async () => {
	try {
		await AlertManager.confirm(t("generic.warning"), t("generic.clearAreYouSure"));
		resetFormData();
	} catch {
		// Too bad
	}
};

const formData = ref<DraftStartupperFormDataDto | null>(null);

const formInfo = inject(providePersonFormInfo);

const privacyPolicyAccepts = ref<PrivacyPolicyAccepts>({});

const privacyPolicies = computed(() => {
	if (!formInfo || !formInfo.value) {
		return [];
	}
	return formInfo.value.publicForm.privacyPolicies;
});

watch(
	privacyPolicies,
	() => {
		privacyPolicyAccepts.value = {};
		privacyPolicies.value.forEach((pp) => {
			privacyPolicyAccepts.value[pp.id] = false;
		});
	},
	{ immediate: true }
);

const allowSave = computed(() => {
	if (!formData.value) {
		return false;
	}

	if (!formData.value.acceptDataSaving) {
		return false;
	}

	if (values(formData.value.privacyPolicyConfirms).some((r) => r == false)) {
		return false;
	}

	return true;
});

return (_ctx: any,_cache: any) => {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_unref(formInfo) && formData.value && formData.value.draftStartupperData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(StartupperFormFields, {
          modelValue: formData.value.draftStartupperData,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.draftStartupperData) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(FormSection, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(FormSectionHeader, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("generic.sectionPrivacy")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyPolicies.value, (pp) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pp.id,
                      class: "my-3"
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_HakoCheckbox, {
                          modelValue: formData.value.privacyPolicyConfirms[pp.id],
                          "onUpdate:modelValue": ($event: any) => ((formData.value.privacyPolicyConfirms[pp.id]) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("generic.haveReadAndAccept")) + " ", 1),
                            _createElementVNode("a", {
                              class: "mx-3",
                              href: makeHttps(pp.url),
                              target: "_blank"
                            }, [
                              _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(pp.translations, "name")) + " ", 1),
                              _createVNode(_component_HakoBsIcon, {
                                icon: "box-arrow-up-right",
                                size: 90
                              })
                            ], 8, _hoisted_6),
                            (!formData.value.privacyPolicyConfirms[pp.id])
                              ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t("generic.required")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]))
                  }), 128)),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_HakoCheckbox, {
                      modelValue: formData.value.acceptDataSaving,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.acceptDataSaving) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(_unref(formInfo).publicForm.translations, "acceptSaveData")) + " ", 1),
                        (!formData.value.acceptDataSaving)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.$t("generic.dataSavingMustAccept")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_HakoButton, {
                onClick: save,
                disabled: !allowSave.value,
                isBlock: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("generic.send")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_HakoButton, {
                onClick: clear,
                isBlock: "",
                theme: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("generic.clear")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})